module.exports = __webpack_public_path__ + "img/PeepsBeside.ed6ba541.svg";